import React from 'react';

const BOOKING_URL = process.env.REACT_APP_BOOKING_URL || 'https://agenda.filtrosyaceitesjm.com/login';

const TemplateTrust = ({ data, config }) => {
  const activeServices = Array.isArray(data?.services) && data.services.length > 0
    ? config.services.filter(s => data.services.includes(s.id))
    : config.services.slice(0, 6);

  const primary = data.brand_color_primary || '#1e3a5f';
  const secondary = data.brand_color_secondary || '#2563eb';
  const secondaryLight = secondary + '25';

  return (
    <div className="min-h-screen bg-blue-50 text-slate-800 font-sans">
      {/* Header Info */}
      <div className="text-white py-2 px-6 text-sm hidden md:flex justify-between items-center" style={{ backgroundColor: primary }}>
        <span>📍 {data.address || 'Ubicación'}</span>
        <span>📞 {data.phone || 'Teléfono de contacto'}</span>
      </div>

      {/* Hero Section */}
      <header className="bg-white py-16 px-6 shadow-sm">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
          <div className="flex-1">
            <span className="font-bold uppercase tracking-wider text-sm mb-4 block" style={{ color: secondary }}>
              Atención Profesional
            </span>
            <h1 className="text-4xl md:text-5xl font-extrabold mb-6 text-slate-900 leading-tight">
              {data.name || config.defaultTitle}
            </h1>
            <p className="text-lg text-slate-600 mb-8">
              {config.defaultDescription}
            </p>
            <div className="flex gap-4">
              <button
                className="text-white px-6 py-3 rounded-lg font-semibold transition-opacity hover:opacity-90"
                style={{ backgroundColor: secondary, boxShadow: `0 4px 14px ${secondary}50` }}
                onClick={() => { window.location.href = `${data.booking_url || BOOKING_URL}?workshopId=${data.id}&niche=${data.niche}`; }}
              >
                Solicitar Cita
              </button>
            </div>
          </div>
          <div className="flex-1 relative">
            <div className="absolute inset-0 rounded-3xl transform translate-x-4 translate-y-4" style={{ backgroundColor: secondaryLight }}></div>
            <img src={data.hero_image_url || config.images[0].url} alt="Especialista" className="relative rounded-3xl shadow-xl object-cover aspect-[4/3] w-full" />
          </div>
        </div>
      </header>

      {/* Trust Badges */}
      <section className="py-8 text-white" style={{ backgroundColor: secondary }}>
        <div className="max-w-6xl mx-auto px-6 flex flex-wrap justify-center gap-8 md:gap-16 text-center text-sm font-semibold tracking-wide uppercase">
          <span>👨‍⚕️ Especialistas</span>
          <span>⭐ Experiencia</span>
          <span>🏥 Tecnología</span>
          <span>🤝 Compromiso</span>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 px-6 relative overflow-hidden" style={{ background: `linear-gradient(160deg, #eef4ff 0%, #f0f6ff 60%, #e8f0fe 100%)` }}>
        <div className="absolute top-10 right-10 w-80 h-80 rounded-full opacity-15 blur-3xl" style={{ backgroundColor: secondary }}></div>
        <div className="absolute bottom-10 left-10 w-60 h-60 rounded-full opacity-10 blur-3xl" style={{ backgroundColor: primary }}></div>

        <div className="relative max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-slate-900">Areas de Especialidad</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {activeServices.map((service, index) => (
              <div
                key={index}
                className="relative p-6 rounded-2xl transition-all duration-300"
                style={{
                  background: 'rgba(255,255,255,0.6)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: `1px solid rgba(255,255,255,0.95)`,
                  boxShadow: `0 4px 20px rgba(0,0,0,0.07), inset 0 1px 0 rgba(255,255,255,1)`,
                }}
              >
                {/* Shine */}
                <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.50) 0%, transparent 40%)' }}></div>
                <div className="absolute top-0 left-6 right-6 h-px" style={{ background: `linear-gradient(to right, transparent, ${secondary}50, transparent)` }}></div>
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 text-2xl"
                  style={{
                    background: `linear-gradient(135deg, ${secondary}22, ${secondary}08)`,
                    border: `1px solid ${secondary}25`,
                    color: secondary,
                  }}
                >
                  {service.icon}
                </div>
                <h3 className="text-lg font-bold capitalize mb-2 text-slate-800">{service.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="pt-16 pb-8 px-6 border-t border-white/5" style={{ backgroundColor: primary, color: 'rgba(255,255,255,0.7)' }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16 mb-12">
            
            {/* 1. Marca y Descripción */}
            <div className="md:col-span-4 flex flex-col">
              <h3 className="text-white font-extrabold text-2xl mb-4 tracking-tight">{data.name}</h3>
              {data.footer_tagline && (
                <p className="text-sm leading-relaxed mb-6" style={{ color: 'rgba(255,255,255,0.6)' }}>
                  {data.footer_tagline}
                </p>
              )}
              <div className="flex flex-wrap gap-2.5 mt-auto">
                {data.whatsapp && (
                  <a href={`https://wa.me/${data.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-white text-xs font-bold transition-opacity hover:opacity-80"
                    style={{ backgroundColor: '#25D366' }}>
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.532 5.855L.057 23.885a.75.75 0 0 0 .92.92l6.104-1.464A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.696 9.696 0 0 1-4.945-1.355l-.355-.21-3.625.869.883-3.538-.23-.367A9.697 9.697 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/></svg>
                    WhatsApp
                  </a>
                )}
                {data.instagram && (
                  <a href={data.instagram} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-white text-xs font-bold transition-opacity hover:opacity-80"
                    style={{ background: 'linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/></svg>
                    Instagram
                  </a>
                )}
                {data.facebook && (
                  <a href={data.facebook} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-white text-xs font-bold transition-opacity hover:opacity-80"
                    style={{ backgroundColor: '#1877F2' }}>
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                    Facebook
                  </a>
                )}
                {data.tiktok && (
                  <a href={data.tiktok} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-full text-white text-xs font-bold transition-opacity hover:opacity-80"
                    style={{ backgroundColor: '#010101', border: '1px solid rgba(255,255,255,0.2)' }}>
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/></svg>
                    TikTok
                  </a>
                )}
              </div>
            </div>

            {/* 2. Info de Contacto */}
            <div className="md:col-span-4 flex flex-col">
              <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-wider">Contacto</h4>
              <ul className="space-y-4 text-sm" style={{ color: 'rgba(255,255,255,0.65)' }}>
                {data.phone && (
                  <li className="flex items-start gap-3">
                    <span className="text-lg leading-none">📞</span>
                    <span className="mt-0.5">{data.phone}</span>
                  </li>
                )}
                {data.address && (
                  <li className="flex items-start gap-3">
                    <span className="text-lg leading-none">📍</span>
                    <span className="mt-0.5">{data.address}{data.city ? `, ${data.city}` : ''}</span>
                  </li>
                )}
              </ul>
            </div>

            {/* 3. Mapa interactivo */}
            {data.address && (
              <div className="md:col-span-4 flex flex-col">
                <h4 className="text-white font-bold mb-6 text-sm uppercase tracking-wider">Ubicación</h4>
                <div className="w-full h-48 rounded-xl overflow-hidden shadow-2xl relative group" style={{ border: '1px solid rgba(255,255,255,0.1)' }}>
                  <iframe
                    title="map"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    style={{ border: 0 }}
                    src={`https://www.google.com/maps?q=${encodeURIComponent(`${data.address}, ${data.city || ''}`)}&output=embed`}
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            )}
          </div>
          
          <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs" style={{ borderTop: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.4)' }}>
            <p>© {new Date().getFullYear()} {data.name}. Todos los derechos reservados.</p>
            <div className="flex gap-6 font-medium">
              <a href="#" className="hover:text-white transition-colors duration-300">Privacidad</a>
              <a href="#" className="hover:text-white transition-colors duration-300">Términos</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TemplateTrust;
